import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatCheckboxModule, MatIconModule, MatToolbarModule } from '@angular/material';
import { MatListModule } from '@angular/material/list';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CompassComponent } from './components/compass/compass.component';
import { NavigationPage } from './page/navigation.page';
import { DistancePipe } from './pipes/distance.pipe';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,

        MatButtonModule,
        MatCheckboxModule,
        MatListModule,
        MatIconModule,
        MatToolbarModule,
        BrowserModule,
        BrowserAnimationsModule,
    ],
    declarations: [
        NavigationPage,
        CompassComponent,
        DistancePipe
    ]
})
export class NavigationModule {
}
